import React from "react"
import aboutAbTest from "../../../assets/images/service/about_abtest.png"
import aboutAbTestMobile from "../../../assets/images/service/about_abtest_mo.png"
import aboutAbTestEn from "../../../assets/images/service/about_abtest_en.png"
import aboutAbTestMobileEn from "../../../assets/images/service/about_abtest_mo_en.png"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import Section from "../../../components/Section/Section"
import { Grid } from "@material-ui/core"
import usePlatform from "../../../hooks/usePlatform"
import useScrollImpressionLog from "../../../hooks/useScrollImpressionLog"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    image: {
      width: "100%",
    },
  })
)
export default function AboutAbTest() {
  const classes = useStyles()
  const { lang } = Locale.getDefault()
  const { isMobile } = usePlatform()

  const { ref } = useScrollImpressionLog({
    message: "서비스소개 : 1_0: A/B 테스트란 무엇일까요?",
    eventKey: "homepage_ab_test_section_1_impression",
  })

  return (
    <Section divRef={ref} className={classes.root}>
      <Grid item xs={12}>
        {lang === "ko" ? (
          <img className={classes.image} src={isMobile ? aboutAbTestMobile : aboutAbTest} alt={"ab test란"} />
        ) : (
          <img className={classes.image} src={isMobile ? aboutAbTestMobileEn : aboutAbTestEn} alt={"about ab test"} />
        )}
      </Grid>
    </Section>
  )
}
